import React from "react";
import A1 from "../assets/a1.png";
import A2 from "../assets/a2.png";

import Background from "./Background";

const ProjectCard = ({
  title,
  description,
  image,
}) => {
  return (
    <div className="max-w-sm rounded-lg overflow-hidden shadow-lg bg-white-200 text-black m-4 transform transition duration-500 hover:scale-105 hover:shadow-xl  hover:shadow-gray-500/50">
      <img
        className="w-full h-50 object-cover rounded-t-lg"
        src={image}
        alt={title}
      />
      <div className="px-6 py-4">
        <div className="font-bold text-xl mb-2">{title}</div>
        <p className="text-slate-700 text-base">{description}</p>
      </div>
      
      
    </div>
  );
};

const Acheivements = () => {
  return (
    <Background>
      <div className="py-12 mt-8">
        <h2 className="text-black text-4xl sm:text-5xl text-center font-extrabold mt-2 pt-4 pb-4">
          My Acheivements
        </h2>
        <div className="flex flex-wrap justify-center">
          {projects.map((project, index) => (
            <ProjectCard
              key={index}
              title={project.title}
              description={project.description}
              image={project.image}
            />
          ))}
        </div>
      </div>
      </Background>
  );
};

const projects = [
  {
    title: "Winners in Speed UI constest",
    description:
      "It was conducted in our college by IOTA Club, which focuses on designing and creating the best websites in limited time. ⏱️💻",

    image: A1,
  },
  {
    title: "Runner-ups in the CrafTech hackathon",
    description:
      "It was a hackathon based on IoT prototype, so we built an all-type health checkup protocol with an app featuring the respective features in it. 🏥📱",
   
    image: A2,
  }
];

export default Acheivements;
